import { Dayjs } from "dayjs"
import { IFreshdeskTicket } from "./freshdeskTicket.types"
import {
  getStatus,
  sourceIcon,
  sourceText,
  FreshdeskStatus,
} from "./freshdeskHelper"
import { Status } from "@/types/Status"
import { IFreshdeskConversation } from "../freshdeskThreadConversation/freshdeskThreadConversation.types"

export enum CommunicationType {
  Complaint = "complaint",
  Freshdesk = "freshdesk",
}

export class FreshdeskTicket implements IFreshdeskTicket {
  id: number
  type: string
  createdDate: Dayjs
  updatedDate: Dayjs
  subject: string
  source: number
  groupId: number
  isSpam: boolean
  statusCode: FreshdeskStatus
  thread: IFreshdeskConversation[]

  constructor(
    id: number,
    type: string,
    createdDate: Dayjs,
    updatedDate: Dayjs,
    subject: string,
    source: number,
    status: number,
    groupId: number,
    isSpam: boolean,
    thread: IFreshdeskConversation[],
  ) {
    this.id = id
    this.type = type
    this.createdDate = createdDate
    this.updatedDate = updatedDate
    this.subject = subject
    this.source = source
    this.statusCode = status
    this.groupId = groupId
    this.isSpam = isSpam
    this.thread = thread
  }

  get isComplaint(): boolean {
    return (
      this.type === "Official Complaint" || this.type === "Complaint Tracker"
    )
  }
  get status(): Status {
    return getStatus(this.statusCode)
  }
  get isOpen(): boolean {
    return (
      this.statusCode !== FreshdeskStatus.Closed &&
      this.statusCode !== FreshdeskStatus.Resolved
    )
  }
  get sourceIcon(): string {
    return sourceIcon(this.source)
  }
  get sourceText(): string {
    return sourceText(this.source)
  }
}
